export default __webpack_public_path__ + "static/logo-1-3d22928d40d0c150df0c18855deab026.svg";